function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Store = function Store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M17.91 1c1.089 0 2.1.585 2.64 1.527l.088.154c.254.442.507.883.752 1.331l.159.289c.296.536.603 1.091.863 1.678.274.614.731 1.642.238 2.752-.267.603-.784 1.105-1.459 1.442L21.19 20.77H22a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h.855V10.195c-.698-.337-1.231-.848-1.505-1.465-.493-1.108-.036-2.136.237-2.751.262-.589.57-1.146.867-1.683l.156-.284c.246-.448.498-.889.753-1.331l.087-.154A3.05 3.05 0 0 1 6.09 1zm-1.122 8.77-.093.085a3 3 0 0 1-2 .767H14c-.35 0-.687-.06-1-.172v10.32h6.19V10.62l-.168-.006a4 4 0 0 1-1.102-.235 4.6 4.6 0 0 1-1.132-.61m-9.577-.003-.167.12q-.466.31-.963.492c-.396.145-.81.226-1.226.242V20.77H11L11 10.45c-.313.112-.65.172-1 .172h-.694a3 3 0 0 1-2.095-.855m1.89 3.075a1 1 0 0 1 1 1v1.5a1 1 0 1 1-2 0v-1.5a1 1 0 0 1 1-1m5.828 0a1 1 0 0 1 1 1v1.5a1 1 0 1 1-2 0v-1.5a1 1 0 0 1 1-1M6.305 3H6.09c-.373 0-.72.2-.904.521l-.09.155c-.247.431-.494.861-.732 1.297l-.16.29c-.288.523-.562 1.018-.79 1.529-.255.574-.35.873-.236 1.127.134.302.607.572 1.176.675.343.062.704.029 1.04-.094q.474-.172.928-.58a3 3 0 0 1-.016-.298zM17.91 3h-.216v4.622q0 .15-.014.298.451.406.925.58c.338.123.698.157 1.042.094.569-.103 1.042-.373 1.175-.674.113-.256.018-.555-.237-1.128-.226-.51-.499-1.002-.787-1.524l-.162-.295q-.36-.652-.733-1.297l-.088-.155A1.05 1.05 0 0 0 17.91 3M11 3H8.306v4.622a1 1 0 0 0 1 1H10c.55 0 1-.448 1-1zm4.694 0H13v4.622a1 1 0 0 0 1 1h.694a1 1 0 0 0 1-1z"
  }));
};
export default Store;